export default {
  initial_principal: 5000,
  contribution_amount: 100,
  contribution_period: 'monthly',
  percent_return: 0.07,
  compounding_period: 'monthly',
  investment_timespan: 5,
};
